import css from 'styled-jsx/css';

export default css`
    footer {
        scroll-snap-align: start;
        scroll-snap-stop: always;
    }
`;
